import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "visitorInfo" */ './index'),
  loading: () => null,
});
